<div class="container">
  <h1 class="page-title">
    <span class="icon"><em class="fas fa-bullhorn"></em></span>{{ 'Announcement.EditHeader' | translate }}
  </h1>
  <p-card>
      <div class="p-fluid">
        <div class="field grid">
          <label class="col-12 mb-2 md:col-1 md:mb-0"><span class="requiredStart">*</span>{{ 'Announcement.HeaderForm.AnnouncementTitle' | translate}}</label>
          <div class="formgroup-inline md:col-8">
            <div class="col-12 md:col-9">
              <input pInputText type="text" [(ngModel)]="announcementEditForm.announcementTitle" [class]="(!announcementEditForm.announcementTitle && firstSave) ? ['ng-invalid', 'ng-dirty'] : []">
            </div>
            <div class="md:col-2">
              <p-checkbox (onChange)="changeCheckBox($event)" [(ngModel)]="this.checkBoxValue" label="{{ 'Announcement.HeaderForm.Edit.ImportantFlag' | translate}}" [binary]="true"></p-checkbox>
            </div>
          </div>
        </div>
        <div class="field grid">
          <label class="col-12 mb-2 md:col-1 md:mb-0"><span class="requiredStart">*</span>{{ 'Announcement.HeaderForm.Edit.Facility' | translate}}</label>
          <div class="formgroup-inline md:col-8">
            <div class="col-12 md:col-3">
              <p-dropdown
                [options]="facilityOptions" [showClear]="true" [filter]="true"
                [(ngModel)]="announcementEditForm.facility"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}" appendTo="body"
                [class]="(!announcementEditForm.facility && firstSave) ? ['ng-invalid', 'ng-dirty'] : []"
                >
              </p-dropdown>
            </div>
          </div>
        </div>
        <div class="field grid">
          <label class="col-12 mb-2 md:col-1 md:mb-0"><span class="requiredStart">*</span>{{ 'Announcement.HeaderForm.AnnouncementDt' | translate}}</label>
          <div class="col-12 md:col-3 laas-calendar">
            <laas-calendar
              #announcementDt
              [validateFunction]="checkRequiredField"
              [enableMaxDateIsToday]="false"
              [showRangeMode]="true"
              (onDateChange)="dateOnChange($event, 'announcementDt')">
            </laas-calendar>
          </div>
        </div>
        <div class="field grid">
          <label class="col-12 mb-2 md:col-1 md:mb-0"><span class="requiredStart">*</span>{{ 'Announcement.HeaderForm.AnnouncementType' | translate}}</label>
          <div class="formgroup-inline md:col-8">
            <div class="col-12 md:col-3">
              <p-dropdown
                [options]="announcementTypeOptions" [showClear]="true" [filter]="true" [(ngModel)]="announcementEditForm.announcementType"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}" appendTo="body"
                [class]="(!announcementEditForm.announcementType && firstSave) ? ['ng-invalid', 'ng-dirty'] : []"
                >
              </p-dropdown>
            </div>
          </div>
        </div>
        <div class="field grid">
          <label class="col-12 mb-2 md:col-1 md:mb-0">{{ 'Announcement.HeaderForm.Edit.UploadFile' | translate}}</label>
          <div class="field grid">
            <div class="mt-4"><input #fileUpload type="file" id="file-uploader" (input)="uploadAnnouncementFile($event, fileUpload)" class="ml-4"></div>
            <div *ngFor="let file of this.fileList" class="announcement-link">
              <p *ngIf="file.docId" class="ml-4"><em class="fas fa-paperclip"></em><a class="moust-pointer" (click)="downloadAnnouncementFile(file.docId,file.name,file.type) " ><span>{{ file.name }}.{{ file.type }} </span></a><button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text" (click)="deleteSelectFile(file)"></button></p>
              <p *ngIf="!file.docId" class="ml-4"><em class="fas fa-paperclip"></em><label>{{ file.name }}.{{ file.type }} </label> <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text" (click)="deleteSelectFile(file)"></button></p>
            </div>
          </div>
        </div>
        <div >

        </div>
      </div>
    <p-editor [(ngModel)]="announcementEditForm.announcementContent" [style]="{'height':'600px'}" [readonly]="!this.isAdmin">
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <select class="ql-header">
            <option value="1">Heading</option>
            <option value="2">Subheading</option>
            <option selected>Normal</option>
          </select>
          <select class="ql-font">
            <option selected>Sans Serif</option>
            <option value="serif">Serif</option>
            <option value="monospace">Monospace</option>
          </select>
        </span>
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-italic" aria-label="Italic"></button>
          <button type="button" class="ql-underline" aria-label="Underline"></button>
        </span>
        <span class="ql-formats">
          <select class="ql-color"></select>
          <select class="ql-background"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered" aria-label="Ordered List" type="button"></button>
          <button class="ql-list" value="bullet" aria-label="Unordered List" type="button"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-link" aria-label="Insert Link" type="button"></button>
          <button class="ql-image" aria-label="Insert Image" type="button"></button>
          <button class="ql-code-block" aria-label="Insert Code Block" type="button"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean" aria-label="Remove Styles" type="button"></button>
        </span>
      </ng-template>
    </p-editor>
    <div class="grid mt-4">
      <div class="col">
          <button pButton pRipple label="{{ 'Announcement.Button.View' | translate }}" (click)="view()"></button>
          <button pButton pRipple label="{{ 'Announcement.Button.Cancel' | translate }}" class="p-button-secondary ml-2" (click)="cancel()"></button>
          <button pButton pRipple label="{{ 'Announcement.Button.Release' | translate }}" class="ml-2 p-button-success" (click)="saveAnnouncement()"></button>
      </div>
    </div>
  </p-card>
</div>
